

import * as htmlToImage from 'html-to-image';

export default {
  props: {
    formation: {
      type: String,
      default: `4-4-2`,
    },
    squad: {
      type: Array,
      default: () => [],
    },
    reset: {
      type: Boolean,
      default: false,
    },
    confirm: {
      type: Boolean,
      default: false,
    },
    sharedPlayers: {
      type: Array,
      default: null,
    },
    selectable: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      selectedPlayers: [],
      activePlayerIndex: null, // Which player is currently being selected
      numSelectedPlayers: 0, // Used to trigger computed
      customFormations: [`4-1-4-1`, `3-1-4-2`, `4-1-3-2`, `4-1-2-1-2`, `3-1-2-1-3`], // Requires custom CSS Grid size
    };
  },
  computed: {
    squadNoSelected () {
      if (this.numSelectedPlayers > 0) {
        const uniqueSquad = [];
        for (const player of [...this.squad]) {
          if (!this.selectedPlayers.includes(player)) {
            uniqueSquad.push(player);
          }
        }
        return uniqueSquad; // Remove selected players
      }
      return this.squad;
    },
    numGroups () {
      return this.formation.split(`-`).length;
    },
    styles () {
      let formationRows = `.5fr repeat(${this.numGroups}, 1fr)`;
      if (this.customFormations.includes(this.formation)) {
        if (this.formation === `4-1-2-1-2` || this.formation === `3-1-2-1-3`) {
          formationRows = `.5fr 1fr .5fr .5fr .5fr 1fr`;
        } else {
          formationRows = `.5fr .75fr .25fr .5fr 1.25fr`;
        }
      }

      const cssVariables = {
        '--formation-rows': formationRows,
        '--formation-row-1': `1fr`, // Goalkeeper
      };

      const trueFormation = this.formation.replace(/-d/g, ``).replace(/-0/g, ``);
      const formationArray = trueFormation.split(`-`);
      for (const [index, value] of formationArray.entries()) {
        // Index + 2 to start from 1 and account for the goalkeepers
        cssVariables[`--formation-row-${index + 2}`] = `repeat(${value}, 1fr)`;
      }
      return cssVariables;
    },
    formationIndexes () {
      // Return a nested array on selectedPlayer indexes for each formation
      const trueFormation = this.formation.replace(/-d/g, ``).replace(/-0/g, ``);
      const formationArray = trueFormation.split(`-`);
      const formationIndexes = [[0]];
      let current = 1;
      for (const line of formationArray) {
        const rowIndexes = [];
        for (let i = 0; i < parseInt(line); i++) {
          rowIndexes.push(current + i);
        }
        formationIndexes.push(rowIndexes);
        current += parseInt(line);
      }
      return formationIndexes;
    },
    disabledClick () {
      return !this.selectable;
    },
  },
  watch: {
    reset (reset) {
      if (reset) {
        this.resetLineup();
      }
    },
    confirm (confirm) {
      if (confirm) {
        this.confirmLineup();
      }
    },
  },
  mounted () {
    this.generatePlayers(); // Either use sharedPlayers or generate 11 blank players
  },
  methods: {
    generatePlayers () {
      if (this.sharedPlayers?.length) {
        const players = [];
        for (const sharedPlayer of this.sharedPlayers) {
          const player = this.squad.find(player => player?.playerId.startsWith(sharedPlayer));
          if (player) {
            players.push(player);
          }
        }
        this.selectedPlayers = players;
      } else {
        this.selectedPlayers = Array(11).fill(null);
      }
    },
    setPlayer (player) {
      this.selectedPlayers[this.activePlayerIndex] = player;
      this.numSelectedPlayers++;
      this.closeSquadList();

      const playerSelected = this.selectedPlayers.filter(player => player !== null);
      if (playerSelected.length === 11) {
        this.$parent.lineupComplete = true;
      }
    },
    closeSquadList () {
      this.activePlayerIndex = null;
    },
    resetLineup () {
      this.selectedPlayers = this.selectedPlayers.map(player => null);
      this.$parent.reset = false;
      this.numSelectedPlayers = 0;
    },
    confirmLineup () {
      this.closeSquadList(); // Remove `Active` styling from potential image
      this.$parent.confirm = false;

      const lineupEl = this.domQs(`[data-selected-lineup]`);
      if (lineupEl) {
        setTimeout(() => {
          htmlToImage.toPng(lineupEl)
            .then(dataUrl => {
              this.$parent.lineupImage = dataUrl;
            })
            .catch(error => {
              console.error(`oops, something went wrong!`, error); // eslint-disable-line no-console
            });
        }, 200); // To account for the deactivating transition
      }

      const playerIds = this.selectedPlayers.map(player => player ? player.player.id.split(`-`)[0] : ``);
      this.$parent.shareUrl = `${window.location.origin}${this.$route.path}?d=${playerIds.join(`,`)}&f=${this.formation}`;
    },
  },
};
